import { Button } from '@pkdigital/pkd-custom-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrackerUtil } from '../../tracking/TrackerUtil';
import { useBranding } from '../../hooks/useBranding';

const onClick = (e: React.MouseEvent<HTMLButtonElement>) => {
  // Tracking
  TrackerUtil.trackBtnClick(
    `td-home_button_${'hero-cta'.split('-')[0]}`,
    `button_${'hero-cta'.split('-')[0]}`
  );

  e.preventDefault();
  const urlParams = new URLSearchParams(window.location.search);
  urlParams.append('alt_home', 'true');
  window.location.href = `/onboarding?${urlParams.toString()}`;
};

export const HeroButton = () => {
  const { t } = useTranslation();
  const branding = useBranding();
  return (
    <Button size={'large'} data-gi={'btn hero-cta'} onClick={onClick}>
      {t(branding === 'hug' ? 'heroSection.button.title-hug' : 'heroSection.button.title')}
    </Button>
  );
};
